import { useMemo, useState, type ReactNode } from "react";

import { MruCountryContext, type MruCountryValue } from "./MruCountryContext";
import type { PhoneCountry } from "./types";

export function MruCountryProvider({ children }: { children: ReactNode }) {
  const [country, setCountry] = useState<PhoneCountry | undefined>(undefined);

  const value = useMemo<MruCountryValue>(
    () => ({
      country,
      setCountry,
    }),
    [country],
  );

  return (
    <MruCountryContext.Provider value={value}>
      {children}
    </MruCountryContext.Provider>
  );
}
